import React, { ReactElement } from 'react';
import Styled from './Column.styled';
import { ComponentProps as Props } from './Column.types';

const Column: React.FC<Props> = ({ children, ...props }): ReactElement<Props> => {
  return <Styled {...props}>{children}</Styled>;
};

export default Column;
